<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        Modifier une offre
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="onClose"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex flex-column ma-3 mt-10">
      <v-textarea
        v-model="offreModifiable.sousTitre"
        :disabled="loading"
        :rules="[rules.required]"
        auto-grow
        class="mb-4"
        counter="100"
        label="Sous titre"
        maxlength="100"
        outlined
        required
        rows="1"
      />
      <v-text-field
        v-if="offre.isAbonnement"
        v-model="offreModifiable.tarifAdherent"
        :disabled="loading"
        :rules="[rules.required, rules.tarifMax]"
        class="mb-4"
        label="Tarif adhérent"
        outlined
        required
        type="number"
      />
      <v-text-field
        v-if="offre.isAbonnement"
        v-model="offreModifiable.tarifCoop"
        :disabled="loading"
        :rules="[rules.required, rules.tarifMax]"
        class="mb-4"
        label="Tarif coopérative"
        outlined
        required
        type="number"
      />
    </div>
    <div class="d-flex justify-space-around">
      <AgrButton
        :disabled="loading"
        class="pa-5"
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        :disabled="isBoutonValiderDisabled"
        class="pa-5"
        @click="enregistrerOffre()"
      >
        Valider
      </AgrButton>
    </div>
  </v-card>
</template>

<script>
import {mapActions} from 'vuex'
import {AgrButton} from '@agrial/ui'
import {clone} from 'lodash'

export default {
  name: 'EditOffreAbonnementModal',
  components: {AgrButton},
  props: {
    offre: {
      type: Object,
      required: true
    },
  },

  data () {
    return {
      loading: false,
      erreur: false,
      offreModifiable: {
        sousTitre: null,
        tarifAdherent: null,
        tarifCoop: null,
      },
      rules: {
        required: value => (value !== null && value !== '') || 'Champ requis',
        tarifMax: value => (value && value <= 99999 ) || 'Tarif max: 99999 euros',
      }
    }
  },

  computed: {
    isBoutonValiderDisabled () {
      return this.loading || this.offreModifiable.sousTitre === null || this.offreModifiable.sousTitre === '' ||
        (this.offre.isAbonnement && (this.offreModifiable.tarifAdherent === null || this.offreModifiable.tarifAdherent === '' || this.offreModifiable.tarifAdherent <= 0 || this.offreModifiable.tarifAdherent >= 99999)) ||
        (this.offre.isAbonnement && (this.offreModifiable.tarifCoop === null || this.offreModifiable.tarifCoop === '' || this.offreModifiable.tarifCoop <= 0 || this.offreModifiable.tarifCoop >= 99999))
    }
  },

  created () {
    this.offreModifiable = clone(this.offre)
  },

  methods: {
    ...mapActions({
      updateOffreAbonnement: 'offreAbonnement/updateOffreAbonnement'
    }),

    enregistrerOffre () {
      this.loading = true
      this.erreur = false

      this.updateOffreAbonnement(this.offreModifiable)
        .then(() => this.$emit('close'))
        .catch(() => this.erreur = true)
        .finally(() => this.loading = false)
    },

    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}

.input-number {
  width: 100%;
}
</style>
